<template>
    <div class="layout__container" v-on:drop.prevent>
        <div class="layout__padding-clear" v-show="launchApp">


            <!--{{this.fileLocation}}<br>-->
            <!--{{this.filename}}-->
            <!--<el-breadcrumb separator-class="el-icon-arrow-right">-->
                <!--<el-breadcrumb-item>My Account</el-breadcrumb-item>-->
                <!--<el-breadcrumb-item>Tools</el-breadcrumb-item>-->
                <!--<el-breadcrumb-item><span class="text__colour-teal">Instant Print Upload</span></el-breadcrumb-item>-->
            <!--</el-breadcrumb>-->
        <!--</div>-->

        <!--<div class="layout__border__radius-10 layout__width-100 layout__position-left layout__padding-15-0 text__align-center text__colour-teal">-->
            <!--<h3>Instant Print Upload</h3>-->
            <!--<p class="layout__padding__top-10px">// todo tagline something like quick order print...</p>-->
        <!--</div>-->


        <div class="layout__width-400px layout__padding-clear">
            <!--<div class="layout__container">-->
                <div class=" colour__background-white">

                    <div class="text__align-center layout__margin__bottom-6px">

                        <img class="component__upload-cloud" src="https://rpsassets.blob.core.windows.net/rpsimages/images/icons/uploadIcon.png"><br>

                        <h2 class="text__colour-teal layout__margin__top-10">Pdf Upload</h2>

                        <p class="layout__margin__top-10">Upload your print ready pdf here</p>

                    </div>

                    <div class="component__upload-portal__leading-dropzone colour__background-white" id="dropzone"
                         @dragover.prevent="ondrag" @drop="ondrop" @dragleave="onleave" v-show="showUploadBool">
                        <h3 class="text__colour-teal text__align-center text__style-bold-900">Drag and drop<br>your
                            pdf here</h3>

                        <el-button class="button-red layout__margin-2-05 button__base layout__width-150px layout__margin__top-10"
                                   v-on:click="showUpload">Or
                            click to upload
                        </el-button>
                    </div>

                    <div class="layout__position-center" id="progress" v-show="showProgressBool">
                        <div class="layout__width-126px layout__height-126px layout__padding-clear layout__margin__top-20px">
                            <el-progress class="layout__position__absolute" type="circle" :width="126" status="exception"
                                         :percentage="uploadPercentage" color="#00859c"></el-progress>
                            <img class="component__upload-progress__icon__leading layout__position__absolute"
                            src="https://rpsassets.blob.core.windows.net/rpsimages/images/instant_print/preview.png">
                        </div>
                    </div>

                    <div id="typeError" v-show="showErrorBool" class="text__align-center">
                        <h1 class="text__colour-red icon-error"></h1>
                        <h4>There's a problem!</h4>
                        <p>Attempting to upload unsupported file types: </p>
                        <div v-for="(errorFile) in fileErrors" v-bind:key="errorFile">
                            <p>{{errorFile}}</p>
                        </div>
                        <br>
                        <p class="text__colour-teal">Supported file type:<br> .pdf</p><br>
                        <el-button class="button-red button__base layout__width-150px" v-on:click="tryAgain()">Try again</el-button>
                    </div>
                    <div id="uploadError" v-show="showUploadErrorBool" class="text__align-center">
                        <h1 class="text__colour-red icon-error"></h1>
                        <h4>There's a problem!</h4><br>
                        <h3>Uploading Error, please try again</h3><br>
                        <el-button class="button-red layout__padding-10px button__base layout__width-150px" v-on:click="tryAgain()">
                            Try again
                        </el-button>
                    </div>
                </div>

                <input type="file" id="leadFiles" ref="leadFiles"
                       v-on:change="buttonUpload()" v-show=false>

        </div>
            </div>

            <!--<el-dialog-->
                    <!--:visible.sync="launchApp"-->
                    <!--:close-on-press-escape="false"-->
                    <!--:close-on-click-modal="false"-->
                    <!--width="860px">-->
            <!--<div v-show="pdfupload">-->
                <!--<iframe class="component__pdfupload" v-bind:src="this.launchPdfUpload"></iframe>-->


                <!--<div>-->
                    <!--&lt;!&ndash;<object type="text/html" v-bind:data="this.launchPdfUpload" width="800px" height="600px" style="overflow:auto;border:5px ridge blue">&ndash;&gt;-->
                    <!--&lt;!&ndash;</object>&ndash;&gt;-->

                    <!--<iframe v-show="pdfupload" class="component__pdfupload" v-bind:src="this.uploadLink"></iframe>-->
                <!--</div>-->

            <!--</div>-->
<!--<iframe class="component__pdfupload" v-bind:src="this.launchPdfUpload"></iframe>-->
            <!--</el-dialog>-->
        <!--</div>-->
    </div>

</template>

<script>
    import Axios from 'axios';
    import {axios} from '@/mixins/Axios.js';
    import Router from '../../../router';

    export default {
        name: "customers",
        mixins: [axios],
        components: {},
        props: {
            // filename: '',
            // fileLocation: '',
        },
        data() {
            return {
                order: {},
                index: '',
                showUploadBool: true,
                showProgressBool: false,
                showErrorBool: false,
                showUploadErrorBool: false,
                fileUploading: '',
                fileUploadingProgress: '',
                fileErrors: [],
                leadFiles: [],
                // filename: '',
                uploadPercentage: 0,
                // fileLocation: '',
                launchApp: true,
                pdfupload: false,
                pdf: {},
                uploadLink: ''
            }
        },
        // computed: {
        //     launchPdfUpload() {
        //         console.log('CUSTOMERHUB')
        //         console.log(this.pdf)
        //         const source = 'CUSTOMERHUB';
        //         const propertyName = this.pdf[0].originalName;
        //
        //         // todo needs to come from cookies
        //         const branchCode = JSON.parse(this.returnCookie("_customer")).ref;
        //         const fileName = this.pdf[0].storageUri;
        //         const reference = 'CUSTOMERHUB'
        //         const token = this.returnCookie("_token");
        //
        //         console.log('https://testpdfupload.azurewebsites.net/?propertyName=' + propertyName + '&branchCode=' + branchCode + "&filename=" + fileName + '&reference=' + reference + '&source=' + source + '&token=' + token)
        //
        //         return 'https://testpdfupload.azurewebsites.net/?propertyName=' + propertyName + '&branchCode=' + branchCode + "&filename=" + fileName + '&reference=' + reference + '&source=' + source + '&token=' + token
        //     }
        // },
        // watch: {
        //     launchPdfUpload() {
        //         console.log('CUSTOMERHUB')
        //         console.log(this.pdf)
        //         const source = 'CUSTOMERHUB';
        //         const propertyName = this.pdf[0].originalName;
        //
        //         // todo needs to come from cookies
        //         const branchCode = JSON.parse(this.returnCookie("_customer")).ref;
        //         const fileName = this.pdf[0].storageUri;
        //         const reference = 'CUSTOMERHUB'
        //         const token = this.returnCookie("_token");
        //
        //         console.log('https://testpdfupload.azurewebsites.net/?propertyName=' + propertyName + '&branchCode=' + branchCode + "&filename=" + fileName + '&reference=' + reference + '&source=' + source + '&token=' + token)
        //
        //         return 'https://testpdfupload.azurewebsites.net/?propertyName=' + propertyName + '&branchCode=' + branchCode + "&filename=" + fileName + '&reference=' + reference + '&source=' + source + '&token=' + token
        //     }
        // },
        methods: {
            tryAgain() {
                this.showUploadBool = true;
                this.showErrorBool = false;
                this.showProgressBool = false;
                this.showUploadErrorBool = false;
                this.fileErrors = []
                this.uploadPercentage = 0
            },
            ondrag() {
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone dragover';
                // event.preventDefault(); // just opening the file
                return false;

            },

            onleave() {
                console.log('on leave')
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
                // event.preventDefault(); // just opening the file
                return false;
            },

            ondrop(event) {
                console.log('onDrop')
                event.stopPropagation();
                event.preventDefault();

                console.log('making post to api')
                console.log(this.job)

                this.leadFiles = event.dataTransfer.files

                this.onUpload();
                document.getElementById('dropzone').className = 'component__upload-portal__leading-dropzone';
            },

            showUpload() {
                document.getElementById('leadFiles').click()
            },
            buttonUpload() {
                console.log('making post to api')
                console.log(this.job)

                this.leadFiles = this.$refs.leadFiles.files;

                console.log(this.leadFiles)
                this.onUpload();

            },
            onUpload() {
                let formData = new FormData();
                const file = this.leadFiles[0];


                // const fileType = file.type

                if (file.type !== "application/pdf") {
                    console.log('file doesnt match')
                    this.fileErrors.push(file.name)

                    this.showUploadBool = false;
                    this.showErrorBool = true;
                    this.showProgressBool = false;
                    this.showUploadErrorBool = false;

                    this.sleep(3000).then(() => {
                        this.$refs.leadFiles.value = ''; // resets the upload - will resolve the bug about reloading a file x2
                        this.tryAgain()
                        // this.fileTypeErrors = []
                    })


                } else {
                    console.log('file does match')
                    formData.append("SOURCE", "PDFUPLOAD");
                    formData.append(file.name, file, file.name);
                    this.showUploadBool = false;
                    this.showErrorBool = false;
                    this.showUploadErrorBool = false;
                    this.showProgressBool = true;

                    this.postFile(formData)
                }
            },
            postFile(formData) {
                // todo need to update the endpoint
                // this.filename = this.leadFiles[0].name
                const uploadFile = `${process.env.VUE_APP_UPLOADAPIHOST}/api/upload`

                Axios.post(uploadFile, formData, {

                    headers: {
                        "content-type": "multipart/form-data",
                        "Access-Control-Allow-Origin": "*",
                        "Authorization": "Bearer " + this.returnCookie("_token")
                    },
                    onUploadProgress: function (uploadEvent) {
                        this.uploadPercentage = Math.round(uploadEvent.loaded / uploadEvent.total * 100);
                    }.bind(this)
                })
                    .then(response => {
                        this.$refs.leadFiles.value = ''; // resets the upload - will resolve the bug about reloading a file x2
                        console.log(response.data[0])

                        this.pdf = response.data[0]




                        // this.fileLocation = response.data[0][0]
                        this.tryAgain()
                        // console.log('asking parent')
                        // console.log(this.fileLocation)
                        // this.launchApp = true
                        // document.getElementById('pdfuploadDialog').click()
                        this.leadFiles = [];

                        console.log('CUSTOMERHUB')
                        console.log(this.pdf)
                        const source = 'MYRAVENSWORTH';
                        // const propertyName = this.pdf[0].uploadFile[0].originalName;

                        // todo needs to come from cookies
                        const branchCode = JSON.parse(this.returnCookie("_customer")).ref;
                        const fileName = this.pdf.storageUri;
                        const reference = this.pdf.originalName;

                        // console.log('https://testpdfupload.azurewebsites.net/?propertyName=' + propertyName + '&branchCode=' + branchCode + "&filename=" + fileName + '&reference=' + reference + '&source=' + source + '&token=' + token)


                        const searchParams = {
                            'propertyName': reference,
                            'branchCode' : branchCode,
                            'filename' : fileName,
                            'reference': reference,
                            'source': source,
                            'token' : this.returnCookie("_token")
                        }

                        console.log('searchParams ', searchParams)


                        Router.push({
                            name: '/instant-print/analysing',
                            params: {
                                searchParams: searchParams,
                            }
                        });


                        // this.uploadLink = 'https://testpdfupload.azurewebsites.net/?propertyName=' + propertyName + '&branchCode=' + branchCode + "&filename=" + fileName + '&reference=' + reference + '&source=' + source + '&token=' + token
                        // this.launchApp = false
                        // this.pdfupload = true
                    })
                    .catch(error => {
                        console.log(error)
                        this.showUploadBool = false;
                        this.showErrorBool = false;
                        this.showProgressBool = false;
                        this.showUploadErrorBool = true;
                        this.leadFiles = [];
                        this.uploadPercentage = 0

                        this.sleep(3000).then(() => {
                            this.$refs.leadFiles.value = ''; // resets the upload - will resolve the bug about reloading a file x2
                            this.tryAgain()
                            // this.fileTypeErrors = []
                        })
                    })
            },
            sleep(time) {
                return new Promise((resolve) => setTimeout(resolve, time));
            }
        }
    };
</script>
